import { SystemRightEnum } from "@finway-group/shared/lib/models"
import { Button, Tooltip } from "antd"
import React from "react"
import { Edit } from "react-feather"
import { useTranslation } from "react-i18next"

import { useIsPersonioEnabled } from "Shared/hooks/featureFlags.hooks"
import { AuthzService } from "Shared/services"

import { ConditionalWrapper } from "./conditionalWrapper"

export default function PersonioActionButton({ onClick, isDisconnected }: { onClick: () => void; isDisconnected: boolean }) {
    const { t } = useTranslation()

    const isPersonioDisabled = !useIsPersonioEnabled()
    const isRightToUpdateGranted = AuthzService.isSystemRightGrantedForLoggedInUser(SystemRightEnum.SYS__INTEGRATION__ALL__UPDATE)
    const isEditButtonDisabled = isPersonioDisabled || !isRightToUpdateGranted
    return (
        <ConditionalWrapper condition={isPersonioDisabled} wrapper={(children) => <Tooltip title={t("tooltips:personio.contact_support_to_enable")}>{children}</Tooltip>}>
            <Button disabled={isEditButtonDisabled} onClick={onClick} className={`ml-8`}>
                {isDisconnected ? <>{t("action:connect")}</> : <Edit style={{ color: "inherit" }} />}
            </Button>
        </ConditionalWrapper>
    )
}
